<template>
  <el-dialog
    :title="$t('profile.contact-delete-dialog.title')"
    :visible="isShown"
    width-size="small"
    height-size="fixed-auto"
    append-to-body
    @close="hideDialog"
  >
    <div
      class="px-24 py-16"
      data-test-id="contact-delete-dialog.message"
    >
      <i18n
        class="el-text el-text--body-24"
        path="profile.contact-delete-dialog.message"
      >
        <template #name>
          <strong>{{ name }}</strong>
        </template>
      </i18n>
    </div>
    <template #footer>
      <el-button
        type="secondary"
        data-test-id="contact-delete-dialog.button-cancel"
        @click="hideDialog"
      >
        {{ $t('action.cancel') }}
      </el-button>
      <el-button
        :loading="isContactDeleting || isContactEditing"
        data-test-id="contact-delete-dialog.button-proceed"
        @click="handleDeleteClick"
      >
        {{ $t('action.proceed') }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { ContactType, isUserContact, hasContactType, resetContactType } from '@/app/domain/Contact';

export default {
  name: 'ContactDeleteDialog',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    isShown: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'hide'
  ],
  computed: {
    ...mapGetters('app', [
      'isContactDeleting',
      'isContactEditing'
    ]),
    name() {
      return this.value
        ? `${this.value.firstName} ${this.value.lastName}`
        : '';
    }
  },
  methods: {
    ...mapActions('app', [
      'deleteContact',
      'editContact'
    ]),
    async handleDeleteClick() {
      if (isUserContact(this.value) || hasContactType(this.value, ContactType.Legal)) {
        await this.editContact(resetContactType(this.value));
      } else {
        await this.deleteContact({ id: this.value.id });
      }
      this.hideDialog();
    },
    hideDialog() {
      this.$emit('hide', false);
    }
  }
};
</script>
